module.exports = "/fonts/hashed/NotoSansKR-SemiBold.31f0f325.ttf.gz.bin";